import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to the top whenever the route's pathname changes.
 *
 * Mounted once inside the Router. Listens only to `pathname` (not `search` or
 * `hash`) so updates to query params via `history.replace({ search })` —
 * commonly used for tab/filter state — don't trigger an unwanted scroll jump.
 */
export const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};
